import dayjs from 'dayjs'

import { DATE_FORMAT } from '@/helpers'
import store from '@/store'

const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

export default {
  formatDate (date) {
    return date ? dayjs(date, DATE_FORMAT).format('DD-MM-YYYY') : ''
  },
  toFixed (value, decimalPlaces = 2) {
    return !isNaN(value) ? value.toFixed(decimalPlaces) : ''
  },
  formatCurrency (value, chosenCurrency = { key: '' }) {
    const selectedCurrency = store.state.currencies.find(i => i.code === chosenCurrency.key) || store.state.currencies[0]
    const currency = { value: 1, ...chosenCurrency, ...selectedCurrency }
    return (value || value === 0) ? `${((parseInt(value) / 100) * currency.value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ${currency.symbol || currency.code || currency.key}` : ''
  }
}
